import { VisualType, ANIMATIONS } from '../constants';
import { addRendition } from '@shared/utils/photoRendition';

export const getImageSource = (mediaType: VisualType, mediaSource: string) => {
  if (mediaType === VisualType.ANIMATION) {
    const animation = ANIMATIONS.find(({ id }) => id === mediaSource);
    return animation?.image;
  }
  // Add medium rendition for user-uploaded images to optimize email size
  return addRendition({ url: mediaSource, renditionSize: 'medium' });
};
